import "core-js/modules/es.object.get-own-property-descriptor";
import _classCallCheck from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

import rpc from '@tencent/vft-rpc-tool';
import { lock } from '@/util/decorator';
import { request } from './util';
var baseUrl = '//vip.video.qq.com/fcgi-bin/comm_cgi';
var RankService = (_class = /*#__PURE__*/function () {
  function RankService() {
    _classCallCheck(this, RankService);
  }

  _createClass(RankService, null, [{
    key: "getMyLight",
    value: function getMyLight() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return rpc('trpc.rocket_girl_activity.dengpai.DengPai', 'GetComment', params, {
        withCredentials: true
      });
    }
  }, {
    key: "getLight",
    value: function getLight() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return rpc('trpc.rocket_girl_activity.dengpai.DengPai', 'GetTopCommentList', params);
    }
  }, {
    key: "updateLight",
    value: function updateLight() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return rpc('trpc.rocket_girl_activity.dengpai.DengPai', 'UpComment', params, {
        withCredentials: true
      });
    }
  }, {
    key: "checkLight",
    value: function checkLight(_ref) {
      var content = _ref.content;
      var options = {
        name: 'uploadcomment',
        cmd: 274,
        content: content
      };
      return request({
        jsonp: false
      })(baseUrl, options);
    }
  }, {
    key: "getRank",
    value: function getRank() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return rpc('trpc.rokie101_concert.fans_top_list.FansTopListSvr', 'GetFansTopList', {
        userNum: params.userNum || 11,
        type: 101
      }, {
        withCredentials: false
      });
    }
  }]);

  return RankService;
}(), (_applyDecoratedDescriptor(_class, "getMyLight", [lock], Object.getOwnPropertyDescriptor(_class, "getMyLight"), _class), _applyDecoratedDescriptor(_class, "updateLight", [lock], Object.getOwnPropertyDescriptor(_class, "updateLight"), _class), _applyDecoratedDescriptor(_class, "checkLight", [lock], Object.getOwnPropertyDescriptor(_class, "checkLight"), _class), _applyDecoratedDescriptor(_class, "getRank", [lock], Object.getOwnPropertyDescriptor(_class, "getRank"), _class)), _class);
export default RankService;